// Рекомендации: друг открыл сайт по ссылке /?ref=<код> — код запоминаем на 60 дней и отправляем с заявками,
// турфирма видит «по рекомендации», рекомендатель получает бонус. Параметр убираем из адреса, чтобы его не копировали дальше.
import { clientId, store } from './storage';

const KEY = 'ref';
const TTL = 60 * 86_400_000;
const CODE = /^[A-Za-z0-9]{8}$/;

interface SavedRef { code: string; at: number }

/** Запомнить код из адреса (вызывается при запуске сайта) */
export function captureRef(href = typeof location !== 'undefined' ? location.href : ''): string | null {
  if (!href) return null;
  let url: URL;
  try { url = new URL(href); } catch { return null; }
  const code = url.searchParams.get('ref');
  if (!code || !CODE.test(code)) return null;
  // Первая рекомендация главнее: не перебиваем код, пока он не устарел
  const prev = store.get<SavedRef | null>(KEY, null);
  if (!prev || Date.now() - prev.at > TTL) store.set(KEY, { code, at: Date.now() });
  url.searchParams.delete('ref');
  try { history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`); } catch { /* не браузер */ }
  return code;
}

/** Код рекомендации, если он ещё действует */
export function refCode(): string | null {
  const r = store.get<SavedRef | null>(KEY, null);
  return r && CODE.test(r.code) && Date.now() - r.at <= TTL ? r.code : null;
}

/** Поля для заявки: браузер клиента (кабинет и уведомления о статусе) и код рекомендации */
export const leadExtras = (): { client: string; ref?: string } => {
  const ref = refCode();
  return ref ? { client: clientId, ref } : { client: clientId };
};
